var map = {
	"./AIGC.svg": "84f2",
	"./ai.svg": "ad4c",
	"./audio.svg": "5b8d",
	"./download.svg": "4dae",
	"./excel.svg": "6599",
	"./floder.svg": "54e9",
	"./gif.svg": "9078",
	"./other.svg": "5f34",
	"./pdf.svg": "f9a1",
	"./pic.svg": "f4cd",
	"./ppt.svg": "0e4c",
	"./ps.svg": "662e",
	"./share.svg": "5306",
	"./video.svg": "8f2b",
	"./word.svg": "bcb8",
	"./xiangqing.svg": "46bc",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";